var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"layout":"prev, pager, next, jumper","total":_vm.totalItems,"page-size":_vm.itemsPerPage,"current-page":_vm.currentPage,"background":""},on:{"update:currentPage":function($event){_vm.currentPage=$event},"update:current-page":function($event){_vm.currentPage=$event},"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }